
import slotWidget from "./slot-widget"

export default {
  components: {
    slotWidget
  },
  props: {
    coreData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
}
